{
  "Earlier": "이전",
  "noAnnouncements": "예약된 유지 관리 활동 및 수정 중인 제품 문제에 대한 정보를 받게 됩니다.",
  "noAnnouncementsTitle": "공지가 여기에 표시됩니다."
}
